import {trail} from '../path/shapes';
import markMultiItemPath from './markMultiItemPath';

export default markMultiItemPath('trail', trail);



//////////////////
// WEBPACK FOOTER
// ./~/vega-scenegraph/src/marks/trail.js
// module id = 1485
// module chunks = 0